// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.discovery-page {
  flex: 1;
  background: #020617;
  overflow-y: auto;
  color: #f8fafc;
  font-family: 'Inter', sans-serif;
}

.discovery-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

/* Header & Banner */
.discovery-header {
  margin-bottom: 40px;
}

.discovery-banner {
  height: 320px;
  background: linear-gradient(135deg, #1e293b 0%, #020617 100%);
  border-radius: 24px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 0 60px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
}

.banner-content {
  position: relative;
  z-index: 10;
  max-width: 600px;
}

.banner-content h1 {
  font-size: 36px;
  font-weight: 900;
  margin-bottom: 15px;
  background: linear-gradient(to right, #ffffff, #94a3b8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.banner-content p {
  font-size: 18px;
  color: #94a3b8;
  margin-bottom: 30px;
}

.discovery-search-large {
  display: flex;
  align-items: center;
  gap: 15px;
  background: #ffffff;
  padding: 12px 20px;
  border-radius: 12px;
  color: #020617;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.discovery-search-large input {
  flex: 1;
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 500;
  outline: none;
  color: #020617;
}

.banner-image-overlay {
  position: absolute;
  right: -40px;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  opacity: 0.1;
  pointer-events: none;
}

.floating-icon {
  transform: rotate(15deg);
}

/* Main Layout */
.discovery-main {
  display: grid;
  grid-template-columns: 240px 1fr;
  gap: 40px;
}

/* Sidebar */
.discovery-sidebar {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sidebar-label {
  font-size: 11px;
  font-weight: 800;
  color: #64748b;
  padding: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.sidebar-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  color: #94a3b8;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  transition: 0.2s;
  text-align: left;
}

.sidebar-item:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #f8fafc;
}

.sidebar-item.active {
  background: #b91c1c;
  color: white;
}

/* Server Cards */
.section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 25px;
  color: #f8fafc;
}

.section-header h2 {
  font-size: 20px;
  font-weight: 800;
}

.servers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.server-discover-card {
  background: #0f172a;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: 0.3s;
  display: flex;
  flex-direction: column;
}

.server-discover-card:hover {
  border-color: rgba(185, 28, 28, 0.3);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.card-top {
  position: relative;
  height: 80px;
  background: linear-gradient(135deg, #1e293b, #0f172a);
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.server-icon-large {
  width: 56px;
  height: 56px;
  background: #b91c1c;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 800;
  color: white;
  border: 4px solid #0f172a;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.server-category-tag {
  font-size: 10px;
  font-weight: 800;
  background: rgba(255, 255, 255, 0.1);
  padding: 4px 10px;
  border-radius: 20px;
  color: #94a3b8;
  text-transform: uppercase;
}

.card-info {
  padding: 20px;
  flex: 1;
}

.server-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.server-name-row h3 {
  font-size: 17px;
  font-weight: 700;
  margin: 0;
}

.verified-icon {
  color: #38bdf8;
}

.server-desc {
  font-size: 14px;
  color: #94a3b8;
  margin-bottom: 15px;
  line-height: 1.5;
  height: 42px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.server-stats {
  display: flex;
  align-items: center;
  gap: 15px;
}

.stat {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.dot.online {
  background: #10b981;
}

.join-btn {
  width: 100%;
  padding: 12px;
  background: #1e293b;
  border: none;
  color: white;
  font-weight: 700;
  cursor: pointer;
  transition: 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.join-btn:hover {
  background: #b91c1c;
}

.no-results {
  grid-column: 1 / -1;
  padding: 80px 0;
  text-align: center;
  color: #64748b;
}

.no-results p {
  margin-top: 15px;
  font-size: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Discovery/Discovery.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,qDAAqD;EACrD,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".discovery-page {\n  flex: 1;\n  background: #020617;\n  overflow-y: auto;\n  color: #f8fafc;\n  font-family: 'Inter', sans-serif;\n}\n\n.discovery-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 40px 20px;\n}\n\n/* Header & Banner */\n.discovery-header {\n  margin-bottom: 40px;\n}\n\n.discovery-banner {\n  height: 320px;\n  background: linear-gradient(135deg, #1e293b 0%, #020617 100%);\n  border-radius: 24px;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  padding: 0 60px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);\n}\n\n.banner-content {\n  position: relative;\n  z-index: 10;\n  max-width: 600px;\n}\n\n.banner-content h1 {\n  font-size: 36px;\n  font-weight: 900;\n  margin-bottom: 15px;\n  background: linear-gradient(to right, #ffffff, #94a3b8);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.banner-content p {\n  font-size: 18px;\n  color: #94a3b8;\n  margin-bottom: 30px;\n}\n\n.discovery-search-large {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  background: #ffffff;\n  padding: 12px 20px;\n  border-radius: 12px;\n  color: #020617;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n}\n\n.discovery-search-large input {\n  flex: 1;\n  background: none;\n  border: none;\n  font-size: 16px;\n  font-weight: 500;\n  outline: none;\n  color: #020617;\n}\n\n.banner-image-overlay {\n  position: absolute;\n  right: -40px;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  opacity: 0.1;\n  pointer-events: none;\n}\n\n.floating-icon {\n  transform: rotate(15deg);\n}\n\n/* Main Layout */\n.discovery-main {\n  display: grid;\n  grid-template-columns: 240px 1fr;\n  gap: 40px;\n}\n\n/* Sidebar */\n.discovery-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.sidebar-label {\n  font-size: 11px;\n  font-weight: 800;\n  color: #64748b;\n  padding: 10px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.sidebar-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 8px;\n  color: #94a3b8;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 600;\n  transition: 0.2s;\n  text-align: left;\n}\n\n.sidebar-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: #f8fafc;\n}\n\n.sidebar-item.active {\n  background: #b91c1c;\n  color: white;\n}\n\n/* Server Cards */\n.section-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 25px;\n  color: #f8fafc;\n}\n\n.section-header h2 {\n  font-size: 20px;\n  font-weight: 800;\n}\n\n.servers-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n.server-discover-card {\n  background: #0f172a;\n  border-radius: 16px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  transition: 0.3s;\n  display: flex;\n  flex-direction: column;\n}\n\n.server-discover-card:hover {\n  border-color: rgba(185, 28, 28, 0.3);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.card-top {\n  position: relative;\n  height: 80px;\n  background: linear-gradient(135deg, #1e293b, #0f172a);\n  padding: 15px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.server-icon-large {\n  width: 56px;\n  height: 56px;\n  background: #b91c1c;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  font-weight: 800;\n  color: white;\n  border: 4px solid #0f172a;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.server-category-tag {\n  font-size: 10px;\n  font-weight: 800;\n  background: rgba(255, 255, 255, 0.1);\n  padding: 4px 10px;\n  border-radius: 20px;\n  color: #94a3b8;\n  text-transform: uppercase;\n}\n\n.card-info {\n  padding: 20px;\n  flex: 1;\n}\n\n.server-name-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.server-name-row h3 {\n  font-size: 17px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.verified-icon {\n  color: #38bdf8;\n}\n\n.server-desc {\n  font-size: 14px;\n  color: #94a3b8;\n  margin-bottom: 15px;\n  line-height: 1.5;\n  height: 42px;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.server-stats {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.stat {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.dot.online {\n  background: #10b981;\n}\n\n.join-btn {\n  width: 100%;\n  padding: 12px;\n  background: #1e293b;\n  border: none;\n  color: white;\n  font-weight: 700;\n  cursor: pointer;\n  transition: 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.join-btn:hover {\n  background: #b91c1c;\n}\n\n.no-results {\n  grid-column: 1 / -1;\n  padding: 80px 0;\n  text-align: center;\n  color: #64748b;\n}\n\n.no-results p {\n  margin-top: 15px;\n  font-size: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
